import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class PhotoEditorToolsMoveService {

  private showMoveOptionsListener = new Subject<any>();
  private hideMoveOptionsListener = new Subject<any>();

  constructor() { }

  public listenShowMoveOptions() {
    return this.showMoveOptionsListener.asObservable();
  }

  public listenHideMoveOptions() {
    return this.hideMoveOptionsListener.asObservable();
  }

  public showMoveOptions() {
    this.showMoveOptionsListener.next();
  }

  public hideMoveOptions() {
    this.hideMoveOptionsListener.next();
  }

}
